<nav class="flex items-center justify-center unicon-navigator">
  <div
    class="box-border flex items-center justify-between w-full px-12 my-auto"
  >
    <!-- Menu left Items -->
    <div class="grid-btn-list">
      <button class="btn-unicon-home hover:shadow-md">
        <img src="unicon.png" alt="" />
      </button>
      <button class="flex items-center justify-center btn-menu hover:shadow-md">
        <ui-icon name="menu" fill="primary-700" size="24" m-size="24" />
      </button>
    </div>

    <!-- Menu Center Items -->
    <div class="nav-list-items-container">
      <ul>
        <ng-container *ngFor="let item of navItems">
          <li [ngClass]="{ selected: item.active }" (click)="goRoute(item)">
            {{ item.name }}
          </li>
        </ng-container>
      </ul>
    </div>

    <!-- Menu Right Items -->
    <ng-container *ngIf="session">
      <unicon-avatar-box
        [fullname]="session.firstName + ' ' + session.lastName"
        [description]="session.roleName"
        [status]="session.statusId"
        [loading]="false"
        [session]="true"
        (valueEmit)="valueReceived($event)"
      />
    </ng-container>
  </div>
</nav>
